export default {
  computed: {
    internalScaffolding () {
      return this.expressionResolver(this.config)
    }
  }
}
